import { DeepPartial } from 'utility-types';
import { Record, String as RTString, Array as RTArray, Static } from 'runtypes';
import { Custodian } from '../custodian';
import { PrimaryCustomer } from '../customer';
import { ExternalBankAccount } from '../bank-acount';
import { ExistingAccount, Investment } from '../investment';

export const TransferApplication = Record({
  custodian: Custodian,
  customer: PrimaryCustomer,
  externalAccounts: RTArray(ExternalBankAccount),
  existingAccounts: RTArray(ExistingAccount).Or(RTArray(Record({}))),
  newInvestments: RTArray(Investment),
  investmentMethod: RTString,
  profileApplicationID: RTString,
  toIRAAccountType: RTString,
  fromIRAAccountType: RTString,
  termsIDs: RTArray(RTString),
  deviceToken: RTString
});

export type StaticTransferApplication = Static<typeof TransferApplication>;
export type OptionalStaticTransferApplication = DeepPartial<
  StaticTransferApplication
>;
